import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import { loginRequest } from '../constants/ms-auth'

// Handles employee sign in via Microsoft Entra ID (Azure AD).
// Mirrors the popup based flow used by the ITS application.
export function useEmployeeAuth() {
  const { instance, accounts, inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  const account = accounts && accounts.length > 0 ? accounts[0] : null

  const login = async () => {
    try {
      await instance.loginPopup(loginRequest)
    } catch (error) {
      console.error('Employee login error:', error)
    }
  }

  const logout = () => {
    // Local sign out only: clear MSAL's cached session without redirecting to
    // the Microsoft logout endpoint (which would prompt an account picker).
    instance
      .logoutRedirect({
        account,
        onRedirectNavigate: () => false,
      })
      .catch(console.error)
  }

  return {
    isAuthenticated,
    account,
    inProgress,
    login,
    logout,
  }
}
